import { getUserPermissions } from './session.helper'

export function getPermissionList() {
  const raw = getUserPermissions()
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

// True when the current user holds the named permission (e.g. "Read Sales Document").
// A falsy permission means "no restriction", so the item is always visible.
export function can(permission) {
  if (!permission) return true
  return getPermissionList().includes(permission)
}
